import React, { useContext, useEffect, useRef, useState } from 'react';
import { FaUsers } from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import axios from 'axios';
import AuthContext from '../../../store/auth-context';
import { GlobalContext } from '../../../store/global-context';
import { useNavigate } from 'react-router-dom';
import { IoMdDownload } from "react-icons/io";
import { errorMessage } from "../../Util/errorMessage";
import PageHeading from "../../Util/PageHeading";

const UserManagement = () => {
  const navigate = useNavigate();
    const authCtx = useContext(AuthContext);
    const globalCtx = useContext(GlobalContext);
    
    const [listOfUsers,setListOfUsers] = useState([]);
  const dt = useRef();
  const [selectedRowCount, setSelectedRowCount] = useState(10);


  useEffect(() => {
    axios.get(`/api/user/list-users`, {
        headers: { Authorization: "Bearer " + authCtx.authTokens.access },
      }).then(response => {
        setListOfUsers(response.data.user_details);
      }).catch((e) => {
        globalCtx.raiseAlert(errorMessage(e), "error");
        if(e.response?.status === 401 || e.response?.status === 403){
          window.location = '/login';
        }
      });
  },[])

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const rowCounts = [
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "100", value: 100 },
  ];

  const enableAccountHandler = (id,type) => {
    axios.post("/api/user/update-account-verification",{id:id,type:type},{
      headers: { Authorization: "Bearer " + authCtx.authTokens.access },
    }).then(response => {
      setListOfUsers(prevState => prevState.map(item => {
        if(item.id === id){
          item.is_verified = response.data.user.is_verified;
        }
        return item;
      }))
    }).catch(e => {
      globalCtx.raiseAlert(errorMessage(e), "error");
      if(e.response?.status === 401 || e.response?.status === 403){
        window.location = '/login';
      }
    });
  }

  const enableUser = (user) => {
    // Ticket 22 (Q37): v1.2's white on #48C9B0 (2.05:1) / #EC7063 (2.97:1) → the portal's success / danger tokens (≥ 5:1)
    return  <div>{!user.is_verified ? <Button style={{backgroundColor:"var(--portal-success)",color:"var(--portal-on-primary)"}} onClick={() => enableAccountHandler(user.id,"enable")}>Enable</Button>:<Button style={{backgroundColor:"var(--portal-danger)",color:"var(--portal-on-primary)"}} onClick={() => enableAccountHandler(user.id,"disable")}>Disable</Button>}</div>;
  }

  return (
    <div style={{ padding: "10px", maxHeight: "100vh", overflow: "hidden" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems:"center",paddingBottom:"10px" }}>
            {/* RCMC-08 (ticket 11, shared shell): the page name is the page's one h1, same look */}
            <PageHeading icon={<FaUsers style={{marginRight:"5px"}} />}>Users</PageHeading>
        </div>
        <div
        style={{
          background: "white",
          borderRadius: "10px",
          maxHeight: "90%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          fontSize: "14px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        }}
      >
        <div
          style={{
            display: "flex",
            paddingBlock: "5px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex",paddingLeft:"10px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Dropdown
                size={"small"}
                value={selectedRowCount}
                onChange={(e) => setSelectedRowCount(e.target.value)}
                options={rowCounts}
                optionLabel="label"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
            }}
          >
            <Button
              type="button"
              rounded
              onClick={() => exportCSV(false)}
              data-pr-tooltip="CSV"
            ><IoMdDownload /></Button>
          </div>
        </div>
        <DataTable
          ref={dt}
          value={listOfUsers}
          paginator
          rows={selectedRowCount}
          stripedRows
          size="small"
          tableStyle={{ minWidth: "50rem", fontSize: "14px" }}
        >
          <Column field="name" header="Name" sortable></Column>
          <Column field="pan_no" header="PAN No" sortable></Column>
          <Column field="email" header="Email" sortable></Column>
          <Column field="phone_no" header="Phone Number" sortable></Column>
          <Column field="is_admin" header="Is Admin" sortable></Column>
          <Column field="" header="Enable/Disable" body={enableUser}></Column>
        </DataTable>
      </div>
    </div>
  )
}

export default UserManagement
